/**
 * Final art map — games import from this module, not from individual files.
 * SVGs are inlined (`?raw`) so `#body` / `#eyes` can blink without colliding ids.
 */
import animalBuffalo from './animal-buffalo.svg?raw'
import animalCar from './animal-car.svg?raw'
import animalCat from './animal-cat.svg?raw'
import animalChicken from './animal-chicken.svg?raw'
import animalDog from './animal-dog.svg?raw'
import animalDuck from './animal-duck.svg?raw'
import animalMotorbike from './animal-motorbike.svg?raw'
import animalPig from './animal-pig.svg?raw'
import curtainBanana from './curtain-banana.svg?raw'
import curtainBush from './curtain-bush.svg?raw'
import curtainHouse from './curtain-house.svg?raw'
import curtainNonLa from './curtain-non-la.svg?raw'
import peekerCat from './peeker-cat.svg?raw'
import peekerDog from './peeker-dog.svg?raw'
import peekerKid from './peeker-kid.svg?raw'
import peekerMoon from './peeker-moon.svg?raw'
import shapeCircleBlue from './shape-circle-blue.svg?raw'
import shapeCircleGreen from './shape-circle-green.svg?raw'
import shapeCircleRed from './shape-circle-red.svg?raw'
import shapeCircleYellow from './shape-circle-yellow.svg?raw'
import shapeSquareBlue from './shape-square-blue.svg?raw'
import shapeSquareGreen from './shape-square-green.svg?raw'
import shapeSquareRed from './shape-square-red.svg?raw'
import shapeSquareYellow from './shape-square-yellow.svg?raw'
import shapeTriangleBlue from './shape-triangle-blue.svg?raw'
import shapeTriangleGreen from './shape-triangle-green.svg?raw'
import shapeTriangleRed from './shape-triangle-red.svg?raw'
import shapeTriangleYellow from './shape-triangle-yellow.svg?raw'
import trayColorBlue from './tray-color-blue.svg?raw'
import trayColorRed from './tray-color-red.svg?raw'
import trayColorYellow from './tray-color-yellow.svg?raw'
import type { AnimalId, ColorTrayColor, HideId, PeekerId, ShapeArtKey } from './ids'

export {
  ANIMAL_IDS,
  COLOR_KINDS,
  COLOR_TRAY_COLORS,
  HIDE_IDS,
  PEEKER_IDS,
  SHAPE_KINDS,
  type AnimalId,
  type ColorKind,
  type ColorTrayColor,
  type HideId,
  type PeekerId,
  type ShapeArtKey,
  type ShapeKind,
} from './ids'

export const ART = {
  peekers: {
    kid: peekerKid,
    cat: peekerCat,
    dog: peekerDog,
    moon: peekerMoon,
  } satisfies Record<PeekerId, string>,
  hides: {
    bush: curtainBush,
    'non-la': curtainNonLa,
    house: curtainHouse,
    banana: curtainBanana,
  } satisfies Record<HideId, string>,
  animals: {
    chicken: animalChicken,
    duck: animalDuck,
    buffalo: animalBuffalo,
    cat: animalCat,
    dog: animalDog,
    pig: animalPig,
    motorbike: animalMotorbike,
    car: animalCar,
  } satisfies Record<AnimalId, string>,
  shapes: {
    'circle-red': shapeCircleRed,
    'circle-yellow': shapeCircleYellow,
    'circle-blue': shapeCircleBlue,
    'circle-green': shapeCircleGreen,
    'square-red': shapeSquareRed,
    'square-yellow': shapeSquareYellow,
    'square-blue': shapeSquareBlue,
    'square-green': shapeSquareGreen,
    'triangle-red': shapeTriangleRed,
    'triangle-yellow': shapeTriangleYellow,
    'triangle-blue': shapeTriangleBlue,
    'triangle-green': shapeTriangleGreen,
  } satisfies Record<ShapeArtKey, string>,
  colorTrays: {
    red: trayColorRed,
    yellow: trayColorYellow,
    blue: trayColorBlue,
  } satisfies Record<ColorTrayColor, string>,
} as const
